/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponseFibuDto } from '../../models/response-fibu-dto';

export interface GetAllFibus$Params {
}

export function getAllFibus(http: HttpClient, rootUrl: string, params?: GetAllFibus$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseFibuDto>> {
  const rb = new RequestBuilder(rootUrl, getAllFibus.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseFibuDto>;
    })
  );
}

getAllFibus.PATH = '/fibu';
